import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ILogger } from '@shure/shared/angular/utils/logging';

import { ObservableRepository } from '../observable-repository';

export interface DeviceAuthenticationStatus {
	id: string;
	authenticated: boolean;
	readonlyMode: boolean;
}
@Injectable({ providedIn: 'root' })
export class DeviceAuthenticationStatusService {
	private readonly logger: ILogger;
	private readonly repository: ObservableRepository<DeviceAuthenticationStatus>;

	constructor(logger: ILogger) {
		{
			this.logger = logger.createScopedLogger('DeviceAuthenticationStatusService');

			this.repository = new ObservableRepository<DeviceAuthenticationStatus>(this.logger, {
				id: 'not set',
				authenticated: false,
				readonlyMode: false
			});
		}
	}

	public getDeviceState$(deviceId: string): Observable<DeviceAuthenticationStatus> {
		return this.repository.get$(deviceId);
	}

	public setDeviceState(
		deviceId: string,
		setAuthentication?: boolean,
		setreadonlyMode?: boolean
	): Observable<DeviceAuthenticationStatus> {
		const updatedState = this.repository.update(deviceId, (repoEntity: DeviceAuthenticationStatus) => {
			this.updateLogic(repoEntity, setAuthentication, setreadonlyMode);
		});
		if (updatedState) {
			return updatedState;
		}
		return this.repository.set$(deviceId, {
			id: deviceId,
			authenticated: setAuthentication ?? false,
			readonlyMode: setreadonlyMode ?? false
		});
	}

	public resetDeviceState(deviceId: string): void {
		this.setDeviceState(deviceId, false, false);
	}

	public getDeviceStates(): DeviceAuthenticationStatus[] {
		return this.repository.getAllEntities();
	}

	private updateLogic(
		record: DeviceAuthenticationStatus,
		setAuthentication?: boolean,
		setReadonlyMode?: boolean
	): void {
		if (setAuthentication !== undefined) {
			record.authenticated = setAuthentication;
		}
		if (setReadonlyMode !== undefined) {
			record.readonlyMode = setReadonlyMode;
		}
	}
}
